// extracted by mini-css-extract-plugin
module.exports = {"layout":"OwnDebugger_layout__amRse","container":"OwnDebugger_container__LxaOK","container__buttons":"OwnDebugger_container__buttons__LSzqE"};